import { Dispatch, ReactNode, SetStateAction, useEffect } from 'react';
import {
  CloseButton,
  SideBarModal,
  SideBarModalOverlay,
  Title
} from './SidebarStyled';

import { colors } from '../../../styles/GlobalStyles';
import { Icon, IconX } from '../../../styles/Icons';

interface SidebarModalType {
  children: ReactNode;
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  hasCloseButton?: boolean;
  overlayClose?: boolean;
  sidebarWidth?: string;
  relative?: boolean;
}

export const SidebarModal = ({
  children,
  isOpen,
  setOpen,
  title,
  hasCloseButton = true,
  overlayClose = false,
  sidebarWidth,
  relative
}: SidebarModalType) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [isOpen]);

  return (
    <>
      <SideBarModalOverlay
        isOpen={isOpen}
        onClick={() => {
          if (!overlayClose) {
            setOpen(false);
          }
        }}></SideBarModalOverlay>
      <SideBarModal
        isOpen={isOpen}
        sidebarWidth={sidebarWidth}
        relative={relative}>
        {title && <Title>{title}</Title>}
        {hasCloseButton && (
          <CloseButton onClick={() => setOpen(false)}>
            <Icon color={colors.neutral900} pointer>
              <IconX />
            </Icon>
          </CloseButton>
        )}
        {children}
      </SideBarModal>
    </>
  );
};
